import { getGenericEndpoint } from './get.api';
import type { GetAntiForgeryResponse } from './types';

export const getAntiForgery = async (lang?: string) => {
	return await getGenericEndpoint<GetAntiForgeryResponse>(
		'errors/anti-forgery',
		lang
	);
};
